/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

import './switch.scss';

const input = require('b_')
    .with('input');

export const Switch = ({
    id,
    label,
    value,
    onChange,
    required,
    disabled,
    error,
}) => (
    <React.Fragment>
        <input
            id={id}
            required={required}
            disabled={disabled}
            className={input({
                error: !!error,
                switch: true,
            })}
            type="checkbox"
            onChange={() => {
                onChange(!value);
            }}
            checked={!!value}
        />
        <label className={input('label', {
            switch: true,
            disabled,
        })} htmlFor={id}>
            <span className={input('button', { switch: true })}/>
        </label>
        <span className={input('text', { switch: true })}>{label}</span>
    </React.Fragment>
);
